'use strict';
// #region menu
var body = document.querySelector('.page__body');
var sideMenu = document.querySelector('.page__menu');
var menuBtn = document.querySelectorAll('.button--menu');
var menuLinks = document.querySelectorAll('.page__menu .nav__link');
function toggleMenu(forceState) {
    var isActive = forceState !== undefined ? forceState : !sideMenu.classList.contains('page__menu--is-active');
    sideMenu.classList.toggle('page__menu--is-active', isActive);
    body.classList.toggle('page__body--no-scroll', isActive);
    menuBtn.forEach(function(btn) {
        btn.classList.toggle('button--menu--is-active', isActive);
    });
}
menuBtn.forEach(function(btn) {
    btn.addEventListener('click', function() {
        return toggleMenu();
    });
});
menuLinks.forEach(function(link) {
    link.addEventListener('click', function() {
        return toggleMenu(false);
    });
});
// #endregion
// #region reviews slider
var slider = document.querySelector('.reviews__slider');
var slides = document.querySelectorAll('.review');
var dotsContainer = document.createElement('div');
dotsContainer.classList.add('reviews__dots');
slider.parentNode.appendChild(dotsContainer);
slides.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.addEventListener('click', function() {
        slider.scrollTo({
            left: i * slider.offsetWidth,
            behavior: 'smooth'
        });
        setActiveDot(i);
    });
    dotsContainer.appendChild(dot);
});
var dots = dotsContainer.querySelectorAll('button');
var setActiveDot = function(index) {
    dots.forEach(function(d) {
        return d.classList.remove('active');
    });
    if (dots[index]) dots[index].classList.add('active');
};
slider.addEventListener('scroll', function() {
    var index = Math.round(slider.scrollLeft / slider.offsetWidth);
    setActiveDot(index);
});
setActiveDot(0);
// #endregion
// #region features slider
var featuresTrack = document.querySelector('.features__track');
if (featuresTrack) {
    var featureSlides = Array.from(featuresTrack.querySelectorAll('.feature'));
    var btnPrev = document.querySelector('.features__arrow--left');
    var btnNext = document.querySelector('.features__arrow--right');
    var curEl = document.querySelector('.features__current');
    var totalEl = document.querySelector('.features__total');
    var featureIndex = 0;
    var featureTotal = featureSlides.length;
    if (totalEl) totalEl.textContent = String(featureTotal).padStart(2, '0');
    var updateFeatureCounter = function() {
        if (curEl) curEl.textContent = String(featureIndex + 1).padStart(2, '0');
    };
    var getSlideLeft = function(i) {
        var trackRect = featuresTrack.getBoundingClientRect();
        var slideRect = featureSlides[i].getBoundingClientRect();
        return slideRect.left - trackRect.left + featuresTrack.scrollLeft;
    };
    var goToFeature = function(i) {
        if (featureTotal === 0) return;
        var targetIndex = i;
        if (targetIndex < 0) targetIndex = featureTotal - 1;
        if (targetIndex >= featureTotal) targetIndex = 0;
        featureIndex = targetIndex;
        var left = getSlideLeft(targetIndex);
        featuresTrack.scrollTo({
            left: left,
            behavior: 'smooth'
        });
    };
    btnNext === null || btnNext === void 0 ? void 0 : btnNext.addEventListener('click', function() {
        return goToFeature(featureIndex + 1);
    });
    btnPrev === null || btnPrev === void 0 ? void 0 : btnPrev.addEventListener('click', function() {
        return goToFeature(featureIndex - 1);
    });
    var ticking = false;
    featuresTrack.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        /* eslint-env browser */ requestAnimationFrame(function() {
            var x = featuresTrack.scrollLeft;
            var nearest = 0;
            var best = Infinity;
            for(var i = 0; i < featureTotal; i++){
                var d = Math.abs(getSlideLeft(i) - x);
                if (d < best) {
                    best = d;
                    nearest = i;
                }
            }
            if (nearest !== featureIndex) {
                featureIndex = nearest;
                updateFeatureCounter();
            }
            ticking = false;
        });
    }, {
        passive: true
    });
    window.addEventListener('resize', function() {
        return goToFeature(featureIndex);
    });
    updateFeatureCounter();
} // #endregion

//# sourceMappingURL=Kickstarter.d5b9769f.js.map
